<div class="calendar-header">
    <button class="icon-button" mat-icon-button (click)="previousClicked('year')">
        <mat-icon>keyboard_double_arrow_left</mat-icon>
    </button>
    <button class="icon-button" mat-icon-button (click)="previousClicked('month')">
        <mat-icon>keyboard_arrow_left</mat-icon>
    </button>
    <button mat-button (click)="startView()">{{ periodLabel }}</button>
    <button mat-button color="primary" (click)="todayClicked()">Today</button>
    <button class="icon-button" mat-icon-button (click)="nextClicked('month')">
        <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
    <button class="icon-button" mat-icon-button (click)="nextClicked('year')">
        <mat-icon>keyboard_double_arrow_right</mat-icon>
    </button>
</div>
